<template>
  <v-select
    v-bind="[fieldProps, $attrs]"
    :items="items"
    v-model="model"
    name="quartos"
    placeholder="Quartos"
    :menu-props="menuProps"
    clearable
    multiple
  >
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item }}</span>
      </v-chip>

      <span v-if="index === 1" class="text-body-2 font-weight-regular">
        (+{{ model.length - 1 }})
      </span>
    </template>
  </v-select>
</template>

<script>
import { mixin } from "./mixin";

const _data = {
  model: null,
  items: ["1", "2", "3", "4", "5", "+5"],
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    menuProps() {
      const height = window.innerHeight - 200;

      return {
        maxHeight: height,
        closeOnContentClick: true,
      };
    },
  },
  watch: {
    $route(v) {
      this.model = v.query.quartos
        ? v.query.quartos.split(",").map((v) => v)
        : null;
    },
  },
  mounted() {
    if (this.$route.query.quartos)
      this.model = this.$route.query.quartos.split(",").map((v) => v);
  },
  mixins: [mixin],
};
</script>
